export function recordKeys<K extends PropertyKey, T>(object: Record<K, T>) {
    return Object.keys(object) as (K)[];
};